import { useMutation } from 'react-query'
import { checkExistingClient, addExistingClient } from 'services/clients'
import { IClientCheckExistingDto, IClientExistingDto, IClientContactInfo } from 'typescript/interfaces/clients'
import { AxiosError } from 'axios'

interface UseClientSearchResult {
  search: (values: IClientCheckExistingDto) => void
  results: Array<IClientExistingDto> | null | undefined
  isLoading: boolean
  error: AxiosError | null
  reset: () => void
}

export function useClientSearch(onError?: (err: AxiosError) => void): UseClientSearchResult {
  const [mutate, { data, isLoading, error, reset }] = useMutation(checkExistingClient, {
    onError: (err) => onError?.(err as AxiosError),
  })

  return {
    search: (values) => mutate(values),
    results: data?.data,
    isLoading,
    error: (error as AxiosError) || null,
    reset,
  }
}

interface UseAddExistingClientResult {
  addClient: (values: IClientContactInfo) => void
  isLoading: boolean
  error: AxiosError | null
  reset: () => void
}

export function useAddExistingClient(onSuccess?: () => void, onError?: (err: AxiosError) => void): UseAddExistingClientResult {
  const [mutate, { isLoading, error, reset }] = useMutation(addExistingClient, {
    onSuccess: () => onSuccess?.(),
    onError: (err) => onError?.(err as AxiosError),
  })

  return {
    addClient: (values) => mutate(values),
    isLoading,
    error: (error as AxiosError) || null,
    reset,
  }
}


